<template>
  <div class="modal_card">

   <div class="header">
      <h4 class="title">
        {{ remote_sim_info.imsi }}
      </h4>
   </div>

    <div  v-if="loading" style="height: 100%" >
      <div class="spinner">
        <scale-loader />
      </div>
    </div>

    <div class="summary" v-else>
      <div class="tab">
        <span
          class="tab_title"
          :class="{ active : block==='Info'}"
          @click="selected_block('Info')"
        >
          {{this.translate('sim_server.main_info.title')}}
        </span>
        <span
          class="tab_title"
          :class="{ active : block==='History'}"
          @click="selected_block('History')"
        >
          {{this.translate('sim_server.history.title')}}
        </span>
        <span
          class="tab_title"
          :class="{ active : block==='Bindings'}"
          @click="selected_block('Bindings')"
        >
          {{this.translate('sim_server.bindings.title')}}
        </span>
      </div>

        <div class="block">
          <RemotSimInfo
            v-if="block==='Info'"
            :remote_sim_info="remote_sim_info"
            @close="close"
            @update="update"
          />
          <ActionsHistory
            v-if="block==='History'"
            :actions_history="actions_history"
            @close="close"
            @update="update"
          />
          <BindingsHistory
            v-if="block==='Bindings'"
            :bindings_history="bindings_history"
            @close="close"
            @update="update"
          />
        </div>
    </div>

    <div class="modal_clients__footer">
        <div class="text-center">
            <span
                class="btn btn-danger btn-fill btn-wd marginButton"
                @click.prevent="close"
            >
                {{ translate('close_modal') }}
            </span>
        </div>
    </div>
  </div>
</template>
<script>

import RemotSimInfo from "@/views/Dashboard/General/RemoteSim/Tabs/RemoteSimList/Modal/Tabs/RemotSimInfo.vue";
import ActionsHistory from "@/views/Dashboard/General/RemoteSim/Tabs/RemoteSimList/Modal/Tabs/ActionsHistory.vue";
import BindingsHistory from "@/views/Dashboard/General/RemoteSim/Tabs/RemoteSimList/Modal/Tabs/BindingsHistory.vue";
export default {
  name: "RemoteSimModal",
  components: {
    RemotSimInfo,
    ActionsHistory,
    BindingsHistory
  },
  props: ['remote_sim_id'],
  data () {
    return {
      remote_sim_info: {},
      actions_history: {},
      bindings_history :{},
      block: 'Info',
      loading: true
    }
  },
  created() {
    this.init()
  },

  methods: {
    selected_block(block){
      this.block = block
    },
    init(){
      this.$http.simcard.getRemoteSimInfo( this.remote_sim_id,(response) => {
        this.remote_sim_info = response.data
        this.actions_history = response.data.actions_history
        this.bindings_history = response.data.bindings_history
        this.loading = false
      })
    },
    close () {
      this.$emit('close')
    },
    update () {
      this.$emit('update')
    },

  }
}
</script>
<style lang="scss" scoped>
.modal_card{
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;
  &__body{
      width: 100%;
  }

  .header{
    text-align: center;
    .title{
      margin-top: 15px;
    }

  }
    .summary{
        height: 600px;
        .tab{
            width: 100%;
            height: 5%;
            display: flex;
            align-content: center;
            justify-content: center;
            flex-direction: row;
            &_title{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                padding: 5px 0;
                cursor: pointer;
                font-weight: 600;
                font-size: 14px;
                text-align: center;
                background-color: #efe9e9;
                border: 1px solid #efe9e9;
                &.active{
                    background-color: #f8f8f8;
                    border-bottom: 1px solid #f8f8f8;
                }
            }
        }
        .block{
            height: 95%;
            border: 1px solid #efe9e9;
            margin-top: -1px;
            padding: 10px 0;
            overflow: auto;
            &::-webkit-scrollbar{
                width: 10px;
            }
        }
    }
}

</style>
